import apiClient from "./apiClient";

export interface LeaseCompany {
  id: number;
  name: string;
  isActive: boolean;
}

const getLeaseCompanies = async (includeInactive = false): Promise<LeaseCompany[]> => {
  return apiClient.get(`/LeaseCompanies?includeInactive=${includeInactive}`);
};

const createLeaseCompany = async (name: string): Promise<LeaseCompany> => {
  return apiClient.post(`/LeaseCompanies`, { name });
};

const setLeaseCompanyActive = async (id: number, isActive: boolean): Promise<LeaseCompany> => {
  return apiClient.patch(`/LeaseCompanies/${id}/active`, { isActive });
};

const leaseCompaniesService = {
  getLeaseCompanies,
  createLeaseCompany,
  setLeaseCompanyActive,
};

export default leaseCompaniesService;
